import { useMemo } from 'react';

import filter from '@Components/Grid/utils/filter';

export default function useFilters() {
  return useMemo(() => [
    filter
      .options.store('siteId', 'Site', 'sites')
      .multi(true),
  ], [])
}
